import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import CompareSlider from "@/components/CompareSlider";
import content from "@/content/siteContent";

export default function WhyPlzSection() {
  const ch = content.chapters.whyPlz;
  return (
    <section id={ch.id} data-testid="chapter-why-plz" className="relative mx-auto max-w-7xl scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
      <SectionHeader num={ch.num} label={ch.label} />
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <Reveal>
          <h2 className="font-heading text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
            {ch.headlineA}
            <span className="text-plz-orange">{ch.headlineAccent}</span>
            {ch.headlineB}
          </h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-plz-slate sm:text-lg">
            {ch.paragraphs.map((p) => (
              <p key={p.slice(0, 24)}>{p}</p>
            ))}
          </div>
          <button
            data-testid="meet-founders-cta"
            data-scroll-to={ch.cta.target}
            className="group mt-8 flex items-center gap-2 font-heading text-sm font-bold text-plz-orange transition-colors hover:text-plz-amber"
          >
            {ch.cta.label}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
          </button>
        </Reveal>
        <Reveal delay={0.15}>
          <figure>
            <CompareSlider
              realSrc={ch.compare.realSrc}
              aiSrc={ch.compare.aiSrc}
              alt={ch.compare.alt}
              realLabel={ch.compare.realLabel}
              aiLabel={ch.compare.aiLabel}
            />
            <figcaption className="mt-4 flex items-center justify-between gap-4">
              <span className="text-sm text-plz-muted">{ch.compare.caption}</span>
              <span className="hidden font-mono text-[10px] uppercase tracking-[0.2em] text-plz-orange sm:block">
                {ch.compare.hint}
              </span>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}
